/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface EcoleSearch
 */
export interface EcoleSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof EcoleSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EcoleSearch
     */
    adresse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof EcoleSearch
     */
    codePostal?: TextSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof EcoleSearch
     */
    codePays?: StringListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof EcoleSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof EcoleSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof EcoleSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof EcoleSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EcoleSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof EcoleSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof EcoleSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the EcoleSearch interface.
 */
export function instanceOfEcoleSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EcoleSearchFromJSON(json: any): EcoleSearch {
    return EcoleSearchFromJSONTyped(json, false);
}

export function EcoleSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcoleSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'adresse': !exists(json, 'adresse') ? undefined : TextSearchFromJSON(json['adresse']),
        'codePostal': !exists(json, 'codePostal') ? undefined : TextSearchFromJSON(json['codePostal']),
        'codePays': !exists(json, 'codePays') ? undefined : StringListSearchFromJSON(json['codePays']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function EcoleSearchToJSON(value?: EcoleSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'adresse': TextSearchToJSON(value.adresse),
        'codePostal': TextSearchToJSON(value.codePostal),
        'codePays': StringListSearchToJSON(value.codePays),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

